import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HARSiteTypeFilter({ facets, filters, removeFilter, setFilter }) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="siteType"
      filters={filters}
      id="site-type"
      label="Site type / broad term"
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
}

export default withSearch(({ facets, filters, removeFilter, setFilter }) => ({
  facets,
  filters,
  removeFilter,
  setFilter,
}))(HARSiteTypeFilter);
